// 등급 행 고르기 — 서버 creator_tier_daily_per_day · creator_tier_monthly_per_month(마이그레이션 20261022100000)와 같은 규칙의 화면 판.
// 훅(useCreatorTierSummary)의 마이그레이션 전 물러나기와 데모 my_tier_rows 가 **같이** 쓴다 — 규칙을 한 곳에(66차 #4).
// 주인은 대소문자 무시(sameOwnerEmail), 같은 날(같은 달) 두 행이면 나중에 계산된 행(computed_at · 67차 #1 · 87차 #3) → 같으면 진행도 높은 행
// → 그래도 같으면 주인 글자 코드순(서버 collate "C" · 63차 #5). 최신부터 n개
import { sameOwnerEmail } from "./likePattern";

const progressOf = (r) => Number(r?.rookie_progress_current ?? -1);
// 계산 시각 — 없으면 가장 옛것(서버 nulls last 와 같게). 서버는 마이크로초까지 보므로 Date.parse(밀리초) 뒤의 세 자리도 따로 본다(69차 #6)
const computedOf = (r) => {
  const raw = String(r?.computed_at ?? "");
  const t = Date.parse(raw);
  if (!Number.isFinite(t)) return [-Infinity, 0];
  const frac = (raw.match(/T[^.]*\.(\d+)/) || [])[1] || "";
  return [t, Number(frac.padEnd(6, "0").slice(3, 6))];
};
// a 가 b 보다 먼저 고를 행인가(서버 order by computed_at desc nulls last, 진행도 desc nulls last, user_email collate "C")
function before(a, b) {
  const [ta, ua] = computedOf(a), [tb, ub] = computedOf(b);
  if (ta !== tb) return ta > tb;
  if (ua !== ub) return ua > ub;
  if (progressOf(a) !== progressOf(b)) return progressOf(a) > progressOf(b);
  return String(a.user_email ?? "") < String(b.user_email ?? "");
}

export function pickTierRows(rows, email, dateKey, n) {
  const mine = (rows || []).filter((r) => r.user_email === undefined || sameOwnerEmail(r.user_email, email));
  const byKey = new Map();
  for (const r of mine) {
    const k = String(r[dateKey]);
    const prev = byKey.get(k);
    if (!prev || before(r, prev)) byKey.set(k, r);
  }
  return [...byKey.values()].sort((a, b) => String(b[dateKey]).localeCompare(String(a[dateKey]))).slice(0, n);
}
